import { useScrollAnimation } from "@/hooks/useScrollAnimation";

export default function CookiesPage() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <div className="min-h-screen bg-background-50">
      {/* Page Header */}
      <section className="relative py-20 md:py-28 px-4 lg:px-8 bg-background-100 rounded-3xl mx-4 lg:mx-8 mt-4 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20dark%20charcoal%20background%20with%20subtle%20golden%20pixel%20and%20data%20node%20patterns%2C%20digital%20cookie%20concept%20aesthetic%2C%20warm%20gold%20accents%20on%20deep%20black%2C%20sophisticated%20minimal%20corporate%20technology%20style%2C%20soft%20gradients%2C%20no%20text&width=1600&height=500&seq=cookies-header-001&orientation=landscape"
            alt=""
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/15" />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center px-3 py-1.5 rounded-md bg-primary-100 mb-6">
            <span className="text-primary-700 text-xs font-bold uppercase tracking-wider">
              法務情報
            </span>
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
            Cookie ポリシー
          </h1>
          <p className="text-foreground-600 text-base max-w-2xl mx-auto">
            最終更新日: 2026年6月1日
          </p>
        </div>
      </section>

      {/* Content */}
      <section
        ref={ref}
        className={`py-16 md:py-20 px-4 lg:px-8 animate-on-scroll ${
          isVisible ? "is-visible" : ""
        }`}
      >
        <div className="max-w-4xl mx-auto">
          <article className="space-y-10">
            {/* Section 1 */}
            <div>
              <h2 className="text-2xl font-bold text-foreground-950 mb-4">
                1. Cookie とは
              </h2>
              <p className="text-foreground-600 text-base leading-relaxed">
                Cookie（クッキー）とは、ウェブサイトが利用者のブラウザに保存する小さなテキストファイルです。
                Cookie により、ウェブサイトは利用者の設定を記憶したり、サイトの利用状況を分析したりすることができます。
                Cookie には個人を特定する情報は含まれていませんが、
                他の情報と組み合わせることで個人を識別できる場合があります。
              </p>
            </div>

            {/* Section 2 */}
            <div>
              <h2 className="text-2xl font-bold text-foreground-950 mb-4">
                2. 当社が使用する Cookie の種類
              </h2>
              <p className="text-foreground-600 text-base leading-relaxed mb-4">
                当社のウェブサイトでは、以下の種類の Cookie を使用しています：
              </p>

              <div className="space-y-5">
                <div className="p-5 rounded-xl bg-background-100">
                  <h3 className="text-foreground-950 font-bold text-base mb-2">
                    必須 Cookie（Strictly Necessary Cookies）
                  </h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    ウェブサイトの基本的な機能を提供するために必要な Cookie です。
                    これには、セッション管理やセキュリティ機能が含まれます。
                    これらの Cookie は常に有効であり、無効にすることはできません。
                  </p>
                </div>

                <div className="p-5 rounded-xl bg-background-100">
                  <h3 className="text-foreground-950 font-bold text-base mb-2">
                    パフォーマンス Cookie（Performance Cookies）
                  </h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    利用者が当社ウェブサイトをどのように利用しているかを把握するための Cookie です。
                    アクセス数、滞在時間、閲覧ページなどの匿名の統計情報を収集し、
                    ウェブサイトの改善に役立てています。当社は Google Analytics を使用しています。
                  </p>
                </div>

                <div className="p-5 rounded-xl bg-background-100">
                  <h3 className="text-foreground-950 font-bold text-base mb-2">
                    機能性 Cookie（Functional Cookies）
                  </h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    利用者の選択（言語設定、地域設定など）を記憶し、
                    よりパーソナライズされた体験を提供するための Cookie です。
                    これらの Cookie を無効にすると、一部の機能が正しく動作しない場合があります。
                  </p>
                </div>
              </div>
            </div>

            {/* Section 3 */}
            <div>
              <h2 className="text-2xl font-bold text-foreground-950 mb-4">
                3. Cookie の管理方法
              </h2>
              <p className="text-foreground-600 text-base leading-relaxed mb-3">
                利用者は、ブラウザの設定を変更することで Cookie の受け入れを拒否したり、
                既存の Cookie を削除したりすることができます。各ブラウザの設定方法は以下の通りです：
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li className="text-foreground-600 text-base">
                  Google Chrome: 設定 → プライバシーとセキュリティ → Cookie と他のサイトデータ
                </li>
                <li className="text-foreground-600 text-base">
                  Mozilla Firefox: オプション → プライバシーとセキュリティ → Cookie とサイトデータ
                </li>
                <li className="text-foreground-600 text-base">
                  Safari: 環境設定 → プライバシー → Cookie と Web サイトデータ
                </li>
                <li className="text-foreground-600 text-base">
                  Microsoft Edge: 設定 → プライバシー、検索、サービス → Cookie
                </li>
              </ul>
              <p className="text-foreground-600 text-sm leading-relaxed mt-4">
                Cookie を無効にした場合、当社ウェブサイトの一部機能がご利用いただけなくなる可能性がありますので、
                あらかじめご了承ください。
              </p>
            </div>

            {/* Section 4 */}
            <div>
              <h2 className="text-2xl font-bold text-foreground-950 mb-4">
                4. 第三者 Cookie
              </h2>
              <p className="text-foreground-600 text-base leading-relaxed">
                当社ウェブサイトでは、第三者が提供するサービス（Google Analytics など）を通じて
                Cookie が設定される場合があります。これらの第三者 Cookie は、
                各サービス提供者のプライバシーポリシーに従って管理されます。
                当社は、これらの第三者 Cookie に関して一切の責任を負いません。
              </p>
            </div>

            {/* Section 5 */}
            <div>
              <h2 className="text-2xl font-bold text-foreground-950 mb-4">
                5. データの保持期間
              </h2>
              <p className="text-foreground-600 text-base leading-relaxed">
                Cookie によって収集されたデータの保持期間は、Cookie の種類によって異なります。
                セッション Cookie はブラウザを閉じると自動的に削除されます。
                永続的 Cookie は、設定された有効期限が切れるまでブラウザに保存されますが、
                利用者はいつでも手動で削除することができます。
              </p>
            </div>

            {/* Section 6 */}
            <div>
              <h2 className="text-2xl font-bold text-foreground-950 mb-4">
                6. 本ポリシーの変更
              </h2>
              <p className="text-foreground-600 text-base leading-relaxed">
                当社は、必要に応じて本 Cookie 政策を改定することがあります。
                重要な変更がある場合は、当社ウェブサイト上で告知いたします。
                変更後も当社ウェブサイトを継続してご利用いただくことで、
                改定後の Cookie 政策に同意したものとみなされます。
              </p>
            </div>

            {/* Section 7 */}
            <div>
              <h2 className="text-2xl font-bold text-foreground-950 mb-4">
                7. 関連ポリシー
              </h2>
              <p className="text-foreground-600 text-base leading-relaxed">
                本 Cookie 政策は、当社の
                <a
                  href="/privacy"
                  className="text-primary-500 font-medium hover:text-primary-600 transition-colors"
                >
                  プライバシーポリシー
                </a>
                および
                <a
                  href="/terms"
                  className="text-primary-500 font-medium hover:text-primary-600 transition-colors"
                >
                  利用規約
                </a>
                と併せてお読みください。
              </p>
            </div>

            {/* Contact Box */}
            <div className="p-5 rounded-xl bg-background-100">
              <p className="text-foreground-950 font-medium text-sm mb-2">
                お問い合わせ
              </p>
              <p className="text-foreground-600 text-sm">
                Cookie 政策に関するご質問は、admin@bankcheckdata-card.jp までご連絡ください。
              </p>
            </div>
          </article>
        </div>
      </section>
    </div>
  );
}